/** @jsxImportSource theme-ui */
import { useBreakpointIndex } from '@theme-ui/match-media';
import React, { FunctionComponent, useContext, useState } from 'react';
import { Dropdown } from 'semantic-ui-react';

import { AppStateContext } from 'api/AppStateContext';
import { isNonMobile } from 'utils/responsive';

import { BdIcon } from 'components/_common/BdIcon';
import { FlexGroup } from 'components/_common/FlexGroup';
import { Typography } from 'components/_common/Typography';

// TODO: 597e3adc: refactor PanelDropdown to be generic on `SortByOption<T, V>` and `onSelect: (val: SortByOption<T, V>) => void`
interface SortByPropsOld {
  prefixLabel?: string;
  selectedValue;
  options; // TODO: 597e3adc: make this prop generic
  expanded?: boolean;
  onSelect: (val: string) => void;
  disabled: boolean;
}

export const PanelDropdown: FunctionComponent<SortByPropsOld> = ({
  prefixLabel = 'Sort by',
  selectedValue,
  options,
  expanded = false,
  onSelect,
  disabled,
}) => {
  const handleChange = (_, { value }) => {
    onSelect && onSelect(value);
  };
  const { appState, amendState } = useContext(AppStateContext);
  const isNonMobileDevice = isNonMobile(useBreakpointIndex());
  const { isPanelDropdownExpanded } = appState;
  const activeOption = options && options.find(x => x.value === selectedValue);
  const activeOptionName = activeOption && activeOption.text;
  const [isExpanded, setIsExpanded] = useState(expanded);

  // TODO: 5cf01bf7: duplicate Dropdown code, except prefix here. maybe use BdDropdown?
  const trigger = (
    <FlexGroup
      prefix={
        <>
          <BdIcon
            name="icon-sort"
            color="deepSea50"
            nomargin
            sx={{
              '&.icon.bd-icon': {
                verticalAlign: 'text-bottom',
                fontSize: '20px',
              },
            }}
          />
          <Typography color="deepSea50" variant="body2" inline sx={{ marginLeft: '7px' }}>
            {' '}
            {prefixLabel}
          </Typography>
        </>
      }
      suffix={
        <BdIcon
          name={
            isNonMobileDevice && isExpanded
              ? 'icon-chevron-up'
              : isNonMobileDevice
              ? 'icon-chevron-down'
              : isPanelDropdownExpanded
              ? 'icon-chevron-up'
              : 'icon-chevron-down'
          }
          color="sea100"
          bold
          nomargin
          sx={{
            '&.icon.bd-icon': {
              verticalAlign: 'text-bottom',
            },
          }}
        />
      }
    >
      <Typography data-testid="activeOptionNameSortby" color="stone90" variant="subtitle2" inline>
        {activeOptionName}
      </Typography>
    </FlexGroup>
  );

  return (
    <div
      data-testid="sortby"
      sx={{
        borderBottom: theme => `1px solid ${theme.colors.stone20}`,
      }}
    >
      <Dropdown
        className="selection"
        icon={null}
        trigger={trigger}
        fluid
        options={options}
        defaultValue={selectedValue}
        disabled={disabled}
        onChange={handleChange}
        onClose={() =>
          isNonMobileDevice ? setIsExpanded(false) : amendState({ isPanelDropdownExpanded: false })
        }
        onOpen={() =>
          isNonMobileDevice ? setIsExpanded(true) : amendState({ isPanelDropdownExpanded: true })
        }
      />
    </div>
  );
};
